import React, { useEffect, useState } from 'react';
import { ItemScheme } from '../../../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../../../Enums/MagicField.enum';
import MagicForm from '../../../../../Components/Form/MagicForm';
import usePatientConsent from '../../../../../Components/PatientProfile/Hooks/usePatientConsent';
import { SelectValue } from '../../../../../Components/Base/Select/Select';

export interface MedicalRequestPolandFormValues {
	referralTo?: string;
	diagnosis?: SelectValue;
	recommendationsAndTreatment?: string;
	identificationNumber?: string;
}

interface Props {
	patientId: string;
	doctorIdentificationNumber?: string;
	onSubmit: (values: MedicalRequestPolandFormValues) => void;
}

const formScheme: ItemScheme[] = [
	{
		type: MagicField.TEXT_FIELD,
		key: 'referralTo',
		title: 'component.medicalRequestPolandForm.referralTo',
	},
	{
		type: MagicField.DIAGNOSIS_CZECH,
		key: 'diagnosis',
		title: 'component.medicalRequestPolandForm.diagnosis',
	},
	{
		type: MagicField.TEXTAREA,
		key: 'recommendationsAndTreatment',
		title: 'component.medicalRequestPolandForm.recommendationsAndTreatment',
	},
	{
		type: MagicField.TEXT_FIELD,
		key: 'identificationNumber',
		title: 'component.medicalRequestPolandForm.identificationNumber',
	},
];

const MedicalRequestPolandForm: React.FC<Props> = ({
	patientId,
	onSubmit,
	doctorIdentificationNumber,
}) => {
	const { isConsentProvided } = usePatientConsent(patientId);
	const [scheme, setScheme] = useState<ItemScheme[]>(formScheme);

	const defaultValues = {
		addToPatientECard: isConsentProvided,
		identificationNumber: doctorIdentificationNumber,
	};

	const handleSubmit = (values: any) => {
		onSubmit(values);
	};

	useEffect(() => {
		let addToScheme: ItemScheme[] = [
			{
				type: MagicField.PATIENT_CONSENT_REQUEST,
				settings: {
					patientId,
				},
			},
			{
				type: MagicField.WHITESPACE,
			},
		];
		if (isConsentProvided) {
			addToScheme = [
				{
					type: MagicField.WHITESPACE,
				},
				{
					type: MagicField.CHECKBOX,
					key: 'addToPatientECard',
					title: 'component.medicalRequestPolandForm.sendToPatientECard',
				},
			];
		}
		setScheme([...formScheme, ...addToScheme]);
	}, [isConsentProvided]);

	return (
		<MagicForm
			formScheme={scheme}
			onSubmit={handleSubmit}
			defaultValues={defaultValues}
		/>
	);
};

export default MedicalRequestPolandForm;
